export default {"src":"/_next/static/media/blobmannoeye.586211c4.svg","height":106,"width":212,"blurWidth":0,"blurHeight":0};